import React from 'react';
import { Container, Typography, Button,Grid} from '@mui/material';
import { motion } from 'framer-motion';
import { fontfamily, primaryColor,buttonHoverColor } from './UtilColorPalate';
import { useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
    const navigate=useNavigate();
    const handleNavigate=()=>{
        navigate('/');
    }
  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', paddingTop: '80px',fontFamily:fontfamily }}>
    
        <Grid container direction="column" alignItems="center" spacing={4}>
          {/* Staggered Animations for Tick Icon */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <motion.svg
                xmlns="http://www.w3.org/2000/svg"
                width="120"
                height="120"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4caf50"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                initial={{ pathLength: 0, rotate: 0 }}
                animate={{ pathLength: 1, rotate: 360 }}
                transition={{
                  duration: 1,
                  ease: 'easeInOut',
                  delay: 0.3,
                }}
              >
                <path d="M20 6L9 17l-5-5" />
              </motion.svg>
            </motion.div>
          </Grid>

          {/* Staggered Heading Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#2E7D32' }}
              fontFamily={fontfamily}
              >
                Thank You for Your Purchase!
              </Typography>
            </motion.div>
          </Grid>

          {/* Staggered Message Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7, ease: 'easeOut' }}
            >
              <Typography
                variant="h6"
                textAlign={"left"}
                color="textSecondary"
                sx={{ maxWidth: '500px', margin: '0 auto' }}
                fontFamily={fontfamily}
              >
                Your order has been successfully placed! We’re processing it and will send you a
                confirmation email shortly.
              </Typography>
            </motion.div>
          </Grid>

          {/* Bouncing Button Animation */}
          <Grid item>
            {/* <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.6,
                delay: 1,
                ease: 'easeOut',
                repeat: Infinity,
                repeatType: 'reverse',
                yoyo: 10,
              }}
            > */}
              <Button
                           variant="contained"
                           onClick={handleNavigate}
                           sx={{
                             mt: 2,
                             ml: 1,
                             px: 4,
                             py: 1,
                             fontFamily: fontfamily,
                             backgroundColor: primaryColor,
                             "&:hover": { backgroundColor: buttonHoverColor },
                             "&:disabled": {
                               backgroundColor: "grey.300",
                             },
                           }}
                         >
                Go to Home Page
              </Button>
            {/* </motion.div> */}
          </Grid>
        </Grid>
      {/* </Paper> */}
    </Container>
  );
};

export default ThankYouPage;
